// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file inventory/v1/integration_service.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file inventory/v1/integration_service.proto.
 */
export const file_inventory_v1_integration_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * @generated from message inventory.v1.ListAllIntegrationsRequest
 */
export type ListAllIntegrationsRequest = Message<"inventory.v1.ListAllIntegrationsRequest"> & {
};

/**
 * Describes the message inventory.v1.ListAllIntegrationsRequest.
 * Use `create(ListAllIntegrationsRequestSchema)` to create a new message.
 */
export const ListAllIntegrationsRequestSchema: GenMessage<ListAllIntegrationsRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_integration_service, 0);

/**
 * @generated from message inventory.v1.ListAllIntegrationsResponse
 */
export type ListAllIntegrationsResponse = Message<"inventory.v1.ListAllIntegrationsResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.Integration integrations = 1;
   */
  integrations: Integration[];
};

/**
 * Describes the message inventory.v1.ListAllIntegrationsResponse.
 * Use `create(ListAllIntegrationsResponseSchema)` to create a new message.
 */
export const ListAllIntegrationsResponseSchema: GenMessage<ListAllIntegrationsResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_integration_service, 1);

/**
 * @generated from message inventory.v1.GetIntegrationRequest
 */
export type GetIntegrationRequest = Message<"inventory.v1.GetIntegrationRequest"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;

  /**
   * @generated from field: string integration_id = 2;
   */
  integrationId: string;
};

/**
 * Describes the message inventory.v1.GetIntegrationRequest.
 * Use `create(GetIntegrationRequestSchema)` to create a new message.
 */
export const GetIntegrationRequestSchema: GenMessage<GetIntegrationRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_integration_service, 2);

/**
 * @generated from message inventory.v1.GetIntegrationResponse
 */
export type GetIntegrationResponse = Message<"inventory.v1.GetIntegrationResponse"> & {
  /**
   * @generated from field: inventory.v1.Integration integration = 1;
   */
  integration?: Integration;
};

/**
 * Describes the message inventory.v1.GetIntegrationResponse.
 * Use `create(GetIntegrationResponseSchema)` to create a new message.
 */
export const GetIntegrationResponseSchema: GenMessage<GetIntegrationResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_integration_service, 3);

/**
 * @generated from message inventory.v1.Integration
 */
export type Integration = Message<"inventory.v1.Integration"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string icon_url = 3;
   */
  iconUrl: string;

  /**
   * @generated from field: inventory.v1.IntegrationCategory category = 4;
   */
  category: IntegrationCategory;

  /**
   * @generated from field: optional inventory.v1.IntegrationStatus status = 5;
   */
  status?: IntegrationStatus;

  /**
   * @generated from field: optional google.protobuf.Timestamp date_added = 6;
   */
  dateAdded?: Timestamp;

  /**
   * @generated from field: string description = 7;
   */
  description: string;

  /**
   * @generated from field: string documentation_url = 8;
   */
  documentationUrl: string;

  /**
   * @generated from field: repeated string data_collected = 9;
   */
  dataCollected: string[];

  /**
   * @generated from field: bool is_unqiue = 10;
   */
  isUnqiue: boolean;
};

/**
 * Describes the message inventory.v1.Integration.
 * Use `create(IntegrationSchema)` to create a new message.
 */
export const IntegrationSchema: GenMessage<Integration> = /*@__PURE__*/
  messageDesc(file_inventory_v1_integration_service, 4);

/**
 * @generated from enum inventory.v1.IntegrationStatus
 */
export enum IntegrationStatus {
  /**
   * @generated from enum value: INTEGRATION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INTEGRATION_STATUS_AVAILABLE = 1;
   */
  AVAILABLE = 1,

  /**
   * Usually means "comming soon"
   *
   * @generated from enum value: INTEGRATION_STATUS_UNAVAILABLE = 2;
   */
  UNAVAILABLE = 2,

  /**
   * @generated from enum value: INTEGRATION_STATUS_ADDED = 3;
   */
  ADDED = 3,

  /**
   * @generated from enum value: INTEGRATION_STATUS_BETA = 4;
   */
  BETA = 4,
}

/**
 * Describes the enum inventory.v1.IntegrationStatus.
 */
export const IntegrationStatusSchema: GenEnum<IntegrationStatus> = /*@__PURE__*/
  enumDesc(file_inventory_v1_integration_service, 0);

/**
 * @generated from enum inventory.v1.IntegrationCategory
 */
export enum IntegrationCategory {
  /**
   * @generated from enum value: INTEGRATION_CATEGORY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INTEGRATION_CATEGORY_IDP = 1;
   */
  IDP = 1,

  /**
   * @generated from enum value: INTEGRATION_CATEGORY_PROCUREMENT = 2;
   */
  PROCUREMENT = 2,

  /**
   * @generated from enum value: INTEGRATION_CATEGORY_GRC = 3;
   */
  GRC = 3,

  /**
   * @generated from enum value: INTEGRATION_CATEGORY_CLOUD_INFRASTRUCTURE = 4;
   */
  CLOUD_INFRASTRUCTURE = 4,

  /**
   * @generated from enum value: INTEGRATION_CATEGORY_PAYMENT = 5;
   */
  PAYMENT = 5,

  /**
   * @generated from enum value: INTEGRATION_CATEGORY_SASE = 6;
   */
  SASE = 6,

  /**
   * @generated from enum value: INTEGRATION_CATEGORY_FILE_SHARING = 7;
   */
  FILE_SHARING = 7,

  /**
   * @generated from enum value: INTEGRATION_CATEGORY_SECURITY_STACK = 8;
   */
  SECURITY_STACK = 8,

  /**
   * @generated from enum value: INTEGRATION_CATEGORY_API_GATEWAY = 9;
   */
  API_GATEWAY = 9,

  /**
   * @generated from enum value: INTEGRATION_CATEGORY_MAIL = 10;
   */
  MAIL = 10,

  /**
   * @generated from enum value: INTEGRATION_CATEGORY_ISSUE_MANAGEMENT = 11;
   */
  ISSUE_MANAGEMENT = 11,

  /**
   * @generated from enum value: INTEGRATION_CATEGORY_AI_TOOLS = 12;
   */
  AI_TOOLS = 12,
}

/**
 * Describes the enum inventory.v1.IntegrationCategory.
 */
export const IntegrationCategorySchema: GenEnum<IntegrationCategory> = /*@__PURE__*/
  enumDesc(file_inventory_v1_integration_service, 1);

/**
 * @generated from service inventory.v1.IntegrationService
 */
export const IntegrationService: GenService<{
  /**
   * @generated from rpc inventory.v1.IntegrationService.ListAllIntegrations
   */
  listAllIntegrations: {
    methodKind: "unary";
    input: typeof ListAllIntegrationsRequestSchema;
    output: typeof ListAllIntegrationsResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.IntegrationService.GetIntegration
   */
  getIntegration: {
    methodKind: "unary";
    input: typeof GetIntegrationRequestSchema;
    output: typeof GetIntegrationResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_inventory_v1_integration_service, 0);

